/** 承接政府重点工作三图：悬停提示挂到 body，避免被卡片 overflow 裁切 */
export const govChartTooltipBase = {
	confine: false,
	appendToBody: true,
	className: 'gov-chart-echarts-tooltip',
	extraCssText: 'z-index:10050;box-shadow:0 4px 16px rgba(0,0,0,0.45);pointer-events:none;',
};

export function mergeGovTooltip(option) {
	return Object.assign({}, govChartTooltipBase, option);
}
